export default __webpack_public_path__ + "static/media/frame_bg.a48da35b.png";